import React from 'react';
import { SalesPage } from './pages/SalesPage';
function App() {
  return <SalesPage data-id="element-0" />;
}
export { App };